
          const templateString = `<header class="header">
  <div class="left">
    <canvas
      class="burger"
      onpointerup="HeyGoodGame.toggleSidebar()"
      id="canvas"
      width="42"
      height="42"
    ></canvas>
    <a class="logo" href="/">
      <img src="" alt="" id="main-logo" />
    </a>
  </div>
  <div class="right">
    <ul class="navbar">
      <li class="faqIcon">
        <a href="/#how-to-play">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
              fill="var(--heygg-primary-color)"
            />
            <path
              d="M8 8.37679C8.00011 7.76792 8.19517 7.1704 8.56453 6.64746C8.93389 6.12452 9.46382 5.69561 10.0982 5.40613C10.7327 5.11665 11.448 4.97736 12.1685 5.003C12.8889 5.02864 13.5878 5.21826 14.1911 5.55179C14.7945 5.88532 15.2798 6.35036 15.5957 6.89769C15.9116 7.44502 16.0464 8.05428 15.9859 8.661C15.9253 9.26772 15.6716 9.84933 15.2516 10.3443C14.8316 10.8392 14.2609 11.2291 13.6 11.4727C13.1245 11.6479 12.7198 11.9365 12.4356 12.303C12.1514 12.6695 12 13.0981 12 13.5362V14"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle cx="12" cy="18" r="1" fill="black" />
          </svg>
        </a>
      </li>
      <li class="settingIcon">
        <a href="{{ dashboardBaseUrl }}/profile?return_to={{ returnTo }}">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Icons Navigation" clip-path="url(#clip0_13571_2007)">
              <path
                id="Subtract"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.4335 3.55098L5.89742 1.61855L5.40181 6.52413L0.684829 7.95954L3.45842 12.036L0.767661 16.1676L5.51265 17.5075L6.10716 22.4021L10.6033 20.3785L14.2049 23.7458L16.3484 19.3056L21.2719 19.5701L20.0598 14.7908L24.0014 11.8287L20.0008 8.94669L21.1162 4.14396L16.1991 4.50773L13.9664 0.111662L10.4335 3.55098ZM14.2818 7.90731L7.95943 9.66995L9.72207 15.9923L16.0444 14.2297L14.2818 7.90731Z"
                fill="var(--heygg-primary-color)"
              />
            </g>
            <defs>
              <clipPath id="clip0_13571_2007">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </a>
      </li>
      <li class="statIcon">
        <a
          href="{{ dashboardBaseUrl }}/dashboard/{{ gameKey }}?return_to={{ returnTo }}"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_12805_2551)">
              <path d="M2 12H6V23H2V12Z" fill="#FCFAFA" />
              <path d="M8 1H17V5H13V23H8V1Z" fill="var(--heygg-primary-color)" />
              <path d="M15 7H22V23H15V7Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_12805_2551">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </a>
      </li>
      <li id="log-in">
        <a
          class="log-in-link"
          href="{{ dashboardBaseUrl }}/login?redirect_uri={{ returnTo }}"
        >
          Log In
        </a>
      </li>
      <li id="sign-up" class="sign-up">
        <a
          class="sign-up-link"
          href="{{ dashboardBaseUrl }}/register?redirect_uri={{ returnTo }}"
        >
          Sign Up
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Icons Navigation">
              <path
                id="Vector 108"
                d="M6 12H18M18 12L12.1463 6M18 12L12.1463 18"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        </a>
      </li>
    </ul>
  </div>
</header>

<div class="sidebar" id="sidebar">
  <div class="sidebar-header">
    <h2 class="greeting">Hey <span id="name"></span>!</h2>
    <p>You have a <span id="current-play-streak">0</span> day streak!</p>
  </div>
  <nav class="sidebar-menu">
    <a
      class="menu-item"
      href="{{ dashboardBaseUrl }}/dashboard/{{ gameKey }}?return_to={{ returnTo }}"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_12887_4394)">
          <path d="M2 12H6V23H2V12Z" fill="#FCFAFA" />
          <path d="M8 1H17V5H13V23H8V1Z" fill="var(--heygg-primary-color)" />
          <path d="M15 7H22V23H15V7Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_12887_4394">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>

      Stats
    </a>
    <a
      class="menu-item"
      href="{{ dashboardBaseUrl }}/dashboard/leaderboard/{{ gameKey }}?return_to={{ returnTo }}"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M10.5 16L8 3.5L21 1L18 7L24.5 12.5L10.5 16Z"
          fill="var(--heygg-primary-color)"
        />
        <path
          d="M3.75641 2.92717C2.81554 3.33142 5.33432 15.1641 6.99979 22.5005C7.109 22.9832 7.70639 22.951 8.57899 22.3191C9.45158 21.6871 5.82939 2.68905 5.60237 2.55271C5.37535 2.41636 4.93249 2.42186 3.75641 2.92717Z"
          fill="white"
        />
      </svg>
      Leaderboard</a
    >
    <!--
    <a class="menu-item" href="#"
      ><svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_12887_4409)">
          <g clip-path="url(#clip1_12887_4409)">
            <path
              d="M8.67774 19.8113C11.7962 22.4443 20.4021 20.0616 21.5 14.5C22.7831 8 19.0727 3.00007 12.7337 3C6.67434 2.99993 4.91493 7.78867 4 10.3323"
              stroke="var(--heygg-primary-color)"
              stroke-width="3"
            />
            <path
              d="M3.81942 15.8509L0 7.83984L10.063 10.2321L3.81942 15.8509Z"
              fill="var(--heygg-primary-color)"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_12887_4409">
            <rect width="24" height="24" fill="white" />
          </clipPath>
          <clipPath id="clip1_12887_4409">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Game Archive
		</a>
    -->
    <a
      class="menu-item"
      href="{{ dashboardBaseUrl }}/auth/discord?return_to={{ returnTo }}"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.881 1.09863L1.17529 2.2919L2.12652 17.9481C2.12652 17.9481 12.1881 17.3046 12.3908 17.3046C12.5935 17.3046 19.0043 21.997 19.0043 21.997L18.3887 16.9695L22.6964 16.6223L21.881 1.09863Z"
          fill="var(--heygg-primary-color)"
        />
        <path
          d="M6 12.4997C6.63416 12.1688 13.5 11.5003 16.5 11.5"
          stroke="black"
          stroke-width="3"
        />
        <path
          d="M5 6.99984C8.5 6.5 17 5.99998 19.5 6"
          stroke="black"
          stroke-width="3"
        />
      </svg>
      Game Community
    </a>
    <a
      class="menu-item"
      href="{{ dashboardBaseUrl }}/profile?return_to={{ returnTo }}"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_12887_4417)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.4333 3.55049L5.89718 1.61806L5.40157 6.52364L0.684585 7.95905L3.45817 12.0355L0.767417 16.1671L5.51241 17.507L6.10691 22.4016L10.6031 20.378L14.2047 23.7454L16.3482 19.3051L21.2716 19.5696L20.0596 14.7903L24.0011 11.8282L20.0006 8.9462L21.116 4.14347L16.1989 4.50724L13.9662 0.111174L10.4333 3.55049ZM14.2815 7.90682L7.95918 9.66946L9.72182 15.9918L16.0442 14.2292L14.2815 7.90682Z"
            fill="var(--heygg-primary-color)"
          />
        </g>
        <defs>
          <clipPath id="clip0_12887_4417">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Settings
    </a>
  </nav>
  <h3>OTHER GOOD GAMES</h3>
  <nav class="sidebar-games">
    <a
      href="https://www.kakuroconquest.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2 -rotate-[8deg]"
      >
        <g filter="url(#filter0_d_11981_5161)">
          <g clipPath="url(#clip0_11981_5161)">
            <rect width="24" height="24" fill="white"></rect>
            <rect x="12" y="12" width="11" height="11" fill="#E3DCDA"></rect>
            <rect x="1" y="1" width="11" height="11" fill="#E3DCDA"></rect>
            <path d="M12 0V24" stroke="black" strokeWidth="0.923077"></path>
            <path d="M0 12H24" stroke="black" strokeWidth="0.923077"></path>
            <path
              d="M9.72456 2.53091V6H8.78276V3.39818H8.76243L8.00357 3.85214V3.05263L8.85729 2.53091H9.72456Z"
              fill="black"
            ></path>
            <path
              d="M13.6885 22V21.3224L14.9826 20.2519C15.0685 20.1808 15.1419 20.1141 15.2028 20.052C15.265 19.9888 15.3124 19.9239 15.3451 19.8572C15.379 19.7906 15.3959 19.7166 15.3959 19.6353C15.3959 19.5461 15.3767 19.4699 15.3384 19.4067C15.3011 19.3434 15.2491 19.2949 15.1825 19.261C15.1159 19.226 15.0391 19.2085 14.9521 19.2085C14.8652 19.2085 14.7884 19.226 14.7218 19.261C14.6563 19.296 14.6055 19.3474 14.5693 19.4151C14.5332 19.4829 14.5151 19.5653 14.5151 19.6624H13.6207C13.6207 19.4185 13.6755 19.2085 13.7851 19.0323C13.8946 18.8561 14.0493 18.7206 14.2492 18.6258C14.4491 18.5309 14.6834 18.4835 14.9521 18.4835C15.2299 18.4835 15.4705 18.5281 15.6737 18.6173C15.8781 18.7054 16.0357 18.8296 16.1463 18.99C16.2581 19.1503 16.314 19.3383 16.314 19.554C16.314 19.6873 16.2864 19.82 16.231 19.9521C16.1757 20.0831 16.0763 20.2282 15.9329 20.3874C15.7895 20.5466 15.5857 20.7364 15.3214 20.9566L14.9962 21.2276V21.2479H16.3513V22H13.6885Z"
              fill="black"
            ></path>
            <path d="M1 1L24 24" stroke="#150C09" strokeWidth="0.923077"></path>
          </g>
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            stroke="black"
            shapeRendering="crispEdges"
          ></rect>
        </g>
        <defs>
          <filter
            id="filter0_d_11981_5161"
            x="0"
            y="0"
            width="26"
            height="26"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            ></feColorMatrix>
            <feOffset dx="2" dy="2"></feOffset>
            <feComposite in2="hardAlpha" operator="out"></feComposite>
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
            ></feColorMatrix>
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11981_5161"
            ></feBlend>
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11981_5161"
              result="shape"
            ></feBlend>
          </filter>
          <clipPath id="clip0_11981_5161">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
      Kakuro Conquest
    </a>
    <a href="https://www.mathler.com" target="_blank" rel="noopener noreferrer">
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2 -rotate-[8deg]"
      >
        <g filter="url(#filter0_d_11955_10209)">
          <g clipPath="url(#clip0_11955_10209)">
            <rect width="24" height="24" fill="white"></rect>
            <path d="M23 12H12V1H23V12Z" fill="#FFED48"></path>
            <path d="M12 23H1V12H12V23Z" fill="#91D67D"></path>
            <path d="M12 0L12 24" stroke="#150C09"></path>
            <path d="M0 12L24 12" stroke="#150C09"></path>
            <path
              d="M4.02095 8.09091V6.86364L6.36186 3.18182H7.4755V4.81818H6.83913L5.57777 6.81818V6.86364H9.03232V8.09091H4.02095ZM6.8505 9V7.71591L6.88459 7.18182V3.18182H8.36186V9H6.8505Z"
              fill="#150C09"
            ></path>
            <path
              d="M17.3629 8.73864V4.53409H18.6357V8.73864H17.3629ZM15.897 7.27273V6H20.1016V7.27273H15.897Z"
              fill="#150C09"
            ></path>
            <path
              d="M7.86293 18.0909V19.2727H5.13565V18.0909H7.86293Z"
              fill="#150C09"
            ></path>
            <path
              d="M15.8004 21V19.8636L17.9709 18.0682C18.1148 17.9489 18.2379 17.8371 18.3402 17.733C18.4444 17.6269 18.5239 17.518 18.5788 17.4062C18.6357 17.2945 18.6641 17.1705 18.6641 17.0341C18.6641 16.8845 18.6319 16.7566 18.5675 16.6506C18.505 16.5445 18.4179 16.4631 18.3061 16.4062C18.1944 16.3475 18.0656 16.3182 17.9197 16.3182C17.7739 16.3182 17.6451 16.3475 17.5334 16.4062C17.4235 16.465 17.3383 16.5511 17.2777 16.6648C17.2171 16.7784 17.1868 16.9167 17.1868 17.0795H15.6868C15.6868 16.6705 15.7786 16.3182 15.9624 16.0227C16.1461 15.7273 16.4055 15.5 16.7408 15.3409C17.076 15.1818 17.469 15.1023 17.9197 15.1023C18.3857 15.1023 18.7891 15.1771 19.13 15.3267C19.4728 15.4744 19.737 15.6828 19.9226 15.9517C20.1101 16.2206 20.2038 16.536 20.2038 16.8977C20.2038 17.1212 20.1574 17.3437 20.0646 17.5653C19.9718 17.785 19.8052 18.0284 19.5646 18.2955C19.3241 18.5625 18.9822 18.8807 18.5391 19.25L17.9936 19.7045V19.7386H20.2663V21H15.8004Z"
              fill="#150C09"
            ></path>
          </g>
          <rect x="0.5" y="0.5" width="23" height="23" stroke="black"></rect>
        </g>
        <defs>
          <filter
            id="filter0_d_11955_10209"
            x="0"
            y="0"
            width="26"
            height="26"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            ></feColorMatrix>
            <feOffset dx="2" dy="2"></feOffset>
            <feComposite in2="hardAlpha" operator="out"></feComposite>
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
            ></feColorMatrix>
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11955_10209"
            ></feBlend>
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11955_10209"
              result="shape"
            ></feBlend>
          </filter>
          <clipPath id="clip0_11955_10209">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
      Mathler
    </a>
    <a
      href="https://www.crosswordle.com"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center mb-4 ml-2 text-gray-0 hover:text-hey-brand-green text-[15px] font-semibold leading-normal"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2 -rotate-[8deg]"
      >
        <g filter="url(#filter0_d_11954_5118)">
          <g clipPath="url(#clip0_11954_5118)">
            <rect width="24" height="24" fill="white"></rect>
            <rect x="12" width="12" height="12" fill="#E3DCDA"></rect>
            <rect y="12" width="12" height="12" fill="#91D67D"></rect>
            <rect x="12" y="12" width="12" height="12" fill="#ECDD53"></rect>
            <rect
              x="1.76514"
              y="1.76562"
              width="6.70832"
              height="6.70832"
              fill="#91D67D"
            ></rect>
            <rect width="12" height="12" fill="white"></rect>
            <path d="M12 0L12 24" stroke="#150C09"></path>
            <path d="M0 12L24 12" stroke="#150C09"></path>
            <path
              d="M4.125 9.75V3.93182H6.63636C7.06818 3.93182 7.44602 4.01705 7.76989 4.1875C8.09375 4.35795 8.34564 4.59754 8.52557 4.90625C8.70549 5.21496 8.79545 5.57576 8.79545 5.98864C8.79545 6.4053 8.70265 6.7661 8.51705 7.07102C8.33333 7.37595 8.07481 7.6108 7.74148 7.77557C7.41004 7.94034 7.02273 8.02273 6.57955 8.02273H5.07955V6.79545H6.26136C6.44697 6.79545 6.60511 6.76326 6.7358 6.69886C6.86837 6.63258 6.9697 6.53883 7.03977 6.41761C7.11174 6.2964 7.14773 6.15341 7.14773 5.98864C7.14773 5.82197 7.11174 5.67992 7.03977 5.5625C6.9697 5.44318 6.86837 5.35227 6.7358 5.28977C6.60511 5.22538 6.44697 5.19318 6.26136 5.19318H5.70455V9.75H4.125Z"
              fill="#150C09"
            ></path>
            <path
              d="M16.3278 9.75H14.6232L16.5437 3.93182H18.7028L20.6232 9.75H18.9187L17.646 5.53409H17.6005L16.3278 9.75ZM16.0096 7.45455H19.2141V8.63636H16.0096V7.45455Z"
              fill="#150C09"
            ></path>
            <path
              d="M4.46484 21V15.1818H6.04439V19.7273H8.39666V21H4.46484Z"
              fill="#150C09"
            ></path>
            <path
              d="M14.7028 14.4318H16.4641L17.6005 16.7955H17.646L18.7823 14.4318H20.5437L18.4073 18.4205V20.25H16.8391V18.4205L14.7028 14.4318Z"
              fill="#150C09"
            ></path>
          </g>
          <rect x="0.5" y="0.5" width="23" height="23" stroke="black"></rect>
        </g>
        <defs>
          <filter
            id="filter0_d_11954_5118"
            x="0"
            y="0"
            width="25.5"
            height="25.5"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            ></feColorMatrix>
            <feOffset dx="1.5" dy="1.5"></feOffset>
            <feComposite in2="hardAlpha" operator="out"></feComposite>
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
            ></feColorMatrix>
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11954_5118"
            ></feBlend>
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11954_5118"
              result="shape"
            ></feBlend>
          </filter>
          <clipPath id="clip0_11954_5118">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
      Crosswordle
    </a>
    <a
      href="https://www.imsqueezy.com"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center mb-4 ml-2 text-gray-0 hover:text-hey-brand-green text-[15px] font-semibold leading-normal"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2 -rotate-[8deg]"
      >
        <g filter="url(#filter0_d_11955_6964)">
          <g clipPath="url(#clip0_11955_6964)">
            <path
              d="M24 0L-1.90735e-06 -1.04907e-06L-2.95642e-06 24L24 24L24 0Z"
              fill="#B2D565"
            ></path>
            <g clipPath="url(#clip1_11955_6964)">
              <path
                d="M1.79961 19.3602C1.79961 19.9788 4.66499 20.644 8.19961 20.644C11.7342 20.644 14.5996 19.9788 14.5996 19.3602C14.5996 18.7417 11.7342 18.2402 8.19961 18.2402C4.66499 18.2402 1.79961 18.7417 1.79961 19.3602Z"
                fill="#150C09"
              ></path>
              <mask id="path-5-inside-1_11955_6964" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.3973 19.8028C17.9709 18.5279 20.3684 15.5603 20.7242 12.4235C20.9357 11.4484 21.1792 10.8184 21.3621 10.3453C21.603 9.72178 21.7387 9.37086 21.557 8.86168C21.3881 8.38827 21.0807 8.22171 20.5673 7.94357C20.1113 7.69648 19.4927 7.36133 18.6643 6.64478C16.4037 4.43946 12.6678 3.65831 9.0927 4.93373C5.56907 6.1908 3.18892 9.09354 2.78198 12.1815C2.59503 13.3396 2.31623 14.0243 2.11271 14.524C1.89196 15.0661 1.75977 15.3907 1.9294 15.8662C2.11186 16.3776 2.43939 16.5646 3.02136 16.8969C3.47501 17.1559 4.08325 17.5032 4.89788 18.1612C7.16528 20.3134 10.8601 21.0647 14.3973 19.8028Z"
                ></path>
              </mask>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.3973 19.8028C17.9709 18.5279 20.3684 15.5603 20.7242 12.4235C20.9357 11.4484 21.1792 10.8184 21.3621 10.3453C21.603 9.72178 21.7387 9.37086 21.557 8.86168C21.3881 8.38827 21.0807 8.22171 20.5673 7.94357C20.1113 7.69648 19.4927 7.36133 18.6643 6.64478C16.4037 4.43946 12.6678 3.65831 9.0927 4.93373C5.56907 6.1908 3.18892 9.09354 2.78198 12.1815C2.59503 13.3396 2.31623 14.0243 2.11271 14.524C1.89196 15.0661 1.75977 15.3907 1.9294 15.8662C2.11186 16.3776 2.43939 16.5646 3.02136 16.8969C3.47501 17.1559 4.08325 17.5032 4.89788 18.1612C7.16528 20.3134 10.8601 21.0647 14.3973 19.8028Z"
                fill="#F0CD29"
              ></path>
              <path
                d="M20.7242 12.4235L19.7469 12.2115L19.7362 12.2608L19.7305 12.3108L20.7242 12.4235ZM21.3621 10.3453L22.2948 10.7058L22.2948 10.7058L21.3621 10.3453ZM20.5673 7.94357L21.0437 7.06433L21.0437 7.06433L20.5673 7.94357ZM18.6643 6.64478L17.966 7.36059L17.9875 7.3815L18.0101 7.40109L18.6643 6.64478ZM2.78198 12.1815L3.7692 12.3409L3.77151 12.3266L3.77341 12.3122L2.78198 12.1815ZM2.11271 14.524L1.18656 14.1469L1.18656 14.1469L2.11271 14.524ZM3.02136 16.8969L2.52552 17.7653L2.52552 17.7653L3.02136 16.8969ZM4.89788 18.1612L5.58631 17.4359L5.55733 17.4084L5.52624 17.3833L4.89788 18.1612ZM19.7305 12.3108C19.4229 15.0227 17.3209 17.6981 14.0613 18.8609L14.7333 20.7446C18.6209 19.3577 21.3138 16.098 21.7178 12.5362L19.7305 12.3108ZM20.4293 9.98482C20.2408 10.4726 19.9751 11.1598 19.7469 12.2115L21.7014 12.6356C21.8964 11.737 22.1177 11.1642 22.2948 10.7058L20.4293 9.98482ZM20.6151 9.19769C20.6459 9.2839 20.645 9.32171 20.6339 9.38328C20.6131 9.49866 20.5608 9.64462 20.4293 9.98482L22.2948 10.7058C22.5191 10.1255 22.8221 9.43184 22.4989 8.52566L20.6151 9.19769ZM20.091 8.82281C20.2242 8.89498 20.3193 8.94673 20.4007 8.99552C20.4796 9.04282 20.5234 9.07444 20.5498 9.09652C20.5729 9.11577 20.5806 9.12612 20.5842 9.13119C20.5879 9.13659 20.5996 9.1542 20.6151 9.19769L22.4989 8.52566C22.1851 7.64612 21.5216 7.32327 21.0437 7.06433L20.091 8.82281ZM18.0101 7.40109C18.9193 8.18753 19.6114 8.563 20.091 8.82281L21.0437 7.06433C20.6111 6.82996 20.0661 6.53512 19.3186 5.88847L18.0101 7.40109ZM9.42872 5.87559C12.6896 4.71224 16.0117 5.45408 17.966 7.36059L19.3626 5.92897C16.7957 3.42483 12.6459 2.60439 8.75669 3.99187L9.42872 5.87559ZM3.77341 12.3122C4.12565 9.63926 6.21549 7.02192 9.42872 5.87559L8.75669 3.99187C4.92265 5.35969 2.25219 8.54783 1.79055 12.0509L3.77341 12.3122ZM1.79476 12.0222C1.62545 13.071 1.37882 13.6748 1.18656 14.1469L3.03886 14.9012C3.25365 14.3738 3.56461 13.6083 3.7692 12.3409L1.79476 12.0222ZM1.18656 14.1469C0.980685 14.6524 0.67358 15.3221 0.987547 16.2022L2.87126 15.5302C2.85544 15.4858 2.85314 15.4639 2.85258 15.4566C2.85206 15.4496 2.85154 15.436 2.85722 15.406C2.86371 15.3718 2.87765 15.3191 2.90873 15.2322C2.94079 15.1425 2.98158 15.0418 3.03886 14.9012L1.18656 14.1469ZM0.987547 16.2022C1.31108 17.1091 1.9831 17.4556 2.52552 17.7653L3.51721 16.0285C3.19983 15.8473 3.06638 15.7667 2.97667 15.6897C2.92829 15.6482 2.9027 15.6183 2.87126 15.5302L0.987547 16.2022ZM2.52552 17.7653C2.96427 18.0158 3.51762 18.3318 4.26952 18.9392L5.52624 17.3833C4.64888 16.6746 3.98574 16.296 3.51721 16.0285L2.52552 17.7653ZM14.0613 18.8609C10.8355 20.0118 7.54829 19.2982 5.58631 17.4359L4.20945 18.8865C6.78227 21.3286 10.8847 22.1177 14.7333 20.7446L14.0613 18.8609Z"
                fill="black"
                mask="url(#path-5-inside-1_11955_6964)"
              ></path>
              <ellipse
                cx="5.61284"
                cy="5.54832"
                rx="5.61284"
                ry="5.54832"
                transform="matrix(-0.941858 -0.336012 -0.336012 0.941858 20.9668 8.06836)"
                fill="#FFDE43"
              ></ellipse>
              <circle
                cx="2"
                cy="2"
                r="2"
                transform="matrix(-1 0 0 1 19 7.99951)"
                fill="white"
              ></circle>
              <circle
                cx="2"
                cy="2"
                r="2"
                transform="matrix(-1 0 0 1 11 7.99951)"
                fill="white"
              ></circle>
              <circle
                cx="1"
                cy="1"
                r="1"
                transform="matrix(-1 0 0 1 10 8.99951)"
                fill="black"
              ></circle>
              <circle
                cx="0.5"
                cy="0.5"
                r="0.5"
                transform="matrix(-1 0 0 1 10 8.99951)"
                fill="white"
              ></circle>
              <circle
                cx="1"
                cy="1"
                r="1"
                transform="matrix(-1 0 0 1 18 8.99951)"
                fill="black"
              ></circle>
              <path
                d="M15 10.9995C15 10.9995 14.4706 11.9995 13.5 11.9995C12.5294 11.9995 12 10.9995 12 10.9995"
                stroke="black"
                strokeLinecap="round"
              ></path>
              <circle
                cx="0.5"
                cy="0.5"
                r="0.5"
                transform="matrix(-1 0 0 1 18 8.99951)"
                fill="white"
              ></circle>
            </g>
          </g>
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            stroke="black"
            shapeRendering="crispEdges"
          ></rect>
        </g>
        <defs>
          <filter
            id="filter0_d_11955_6964"
            x="0"
            y="0"
            width="26"
            height="26"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            ></feColorMatrix>
            <feOffset dx="2" dy="2"></feOffset>
            <feComposite in2="hardAlpha" operator="out"></feComposite>
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
            ></feColorMatrix>
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11955_6964"
            ></feBlend>
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11955_6964"
              result="shape"
            ></feBlend>
          </filter>
          <clipPath id="clip0_11955_6964">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
          <clipPath id="clip1_11955_6964">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
      Squeezy
    </a>
    <a
      href="https://www.sumplete.com"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center mb-4 ml-2 text-gray-0 hover:text-hey-brand-green text-[15px] font-semibold leading-normal"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2 -rotate-[8deg]"
      >
        <g filter="url(#filter0_d_11954_5094)">
          <g clipPath="url(#clip0_11954_5094)">
            <rect width="24" height="24" fill="white"></rect>
            <path d="M12 0L12 24" stroke="#150C09"></path>
            <circle cx="6.5" cy="6.5" r="4.5" fill="#91D67D"></circle>
            <path d="M0 12L24 12" stroke="#150C09"></path>
            <path
              d="M7.7152 3.18182V9H6.13565V4.63636H6.10156L4.82884 5.39773V4.05682L6.26065 3.18182H7.7152Z"
              fill="#150C09"
            ></path>
            <path
              d="M15.8004 9V7.86364L17.9709 6.06818C18.1148 5.94886 18.2379 5.83712 18.3402 5.73295C18.4444 5.62689 18.5239 5.51799 18.5788 5.40625C18.6357 5.29451 18.6641 5.17045 18.6641 5.03409C18.6641 4.88447 18.6319 4.75663 18.5675 4.65057C18.505 4.54451 18.4179 4.46307 18.3061 4.40625C18.1944 4.34754 18.0656 4.31818 17.9197 4.31818C17.7739 4.31818 17.6451 4.34754 17.5334 4.40625C17.4235 4.46496 17.3383 4.55114 17.2777 4.66477C17.2171 4.77841 17.1868 4.91667 17.1868 5.07955H15.6868C15.6868 4.67045 15.7786 4.31818 15.9624 4.02273C16.1461 3.72727 16.4055 3.5 16.7408 3.34091C17.076 3.18182 17.469 3.10227 17.9197 3.10227C18.3857 3.10227 18.7891 3.17708 19.13 3.3267C19.4728 3.47443 19.737 3.68277 19.9226 3.9517C20.1101 4.22064 20.2038 4.53598 20.2038 4.89773C20.2038 5.12121 20.1574 5.34375 20.0646 5.56534C19.9718 5.78504 19.8052 6.02841 19.5646 6.29545C19.3241 6.5625 18.9822 6.88068 18.5391 7.25L17.9936 7.70455V7.73864H20.2663V9H15.8004Z"
              fill="#150C09"
            ></path>
            <path
              d="M6.45987 21.0795C6.00154 21.0795 5.59434 21.0009 5.23828 20.8438C4.88411 20.6847 4.60571 20.4659 4.40305 20.1875C4.2004 19.9091 4.09813 19.589 4.09624 19.2273H5.68714C5.68904 19.339 5.72313 19.4394 5.78942 19.5284C5.8576 19.6155 5.9504 19.6837 6.06783 19.733C6.18525 19.7822 6.31972 19.8068 6.47124 19.8068C6.61707 19.8068 6.74586 19.7812 6.8576 19.7301C6.96934 19.6771 7.05646 19.6042 7.11896 19.5114C7.18146 19.4186 7.21177 19.3125 7.20987 19.1932C7.21177 19.0758 7.17578 18.9716 7.10192 18.8807C7.02995 18.7898 6.92862 18.7187 6.79794 18.6676C6.66726 18.6165 6.51669 18.5909 6.34624 18.5909H5.75533V17.5H6.34624C6.50343 17.5 6.64169 17.4744 6.76101 17.4233C6.88222 17.3722 6.97597 17.3011 7.04226 17.2102C7.11044 17.1193 7.14358 17.0152 7.14169 16.8977C7.14358 16.7841 7.11612 16.6837 7.0593 16.5966C7.00249 16.5095 6.92294 16.4413 6.82067 16.392C6.72029 16.3428 6.60381 16.3182 6.47124 16.3182C6.3273 16.3182 6.19851 16.3437 6.08487 16.3949C5.97313 16.446 5.88506 16.517 5.82067 16.608C5.75627 16.6989 5.72313 16.803 5.72124 16.9205H4.20987C4.21177 16.5644 4.3093 16.25 4.50249 15.9773C4.69756 15.7045 4.96461 15.4905 5.30362 15.3352C5.64264 15.1799 6.03184 15.1023 6.47124 15.1023C6.90116 15.1023 7.28089 15.1752 7.61044 15.321C7.94188 15.4669 8.2004 15.6676 8.38601 15.9233C8.57351 16.1771 8.66631 16.4678 8.66442 16.7955C8.66821 17.1212 8.55646 17.3883 8.32919 17.5966C8.10381 17.8049 7.81783 17.928 7.47124 17.9659V18.0114C7.94093 18.0625 8.29415 18.2064 8.5309 18.4432C8.76764 18.678 8.88411 18.9735 8.88033 19.3295C8.88222 19.6705 8.77995 19.9725 8.57351 20.2358C8.36896 20.4991 8.08393 20.7055 7.71839 20.8551C7.35476 21.0047 6.93525 21.0795 6.45987 21.0795Z"
              fill="#150C09"
            ></path>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.2414 17.8304L13.0562 21.0657L14.5819 22.5678L17.7438 19.3563L20.9056 22.5678L22.4314 21.0657L19.2461 17.8304L22.431 14.5954L20.9053 13.0933L17.7438 16.3044L14.5823 13.0933L13.0565 14.5954L16.2414 17.8304Z"
              fill="#FF6741"
            ></path>
            <path
              d="M15.521 20.0909V18.8636L17.8619 15.1818H18.9755V16.8182H18.3391L17.0778 18.8182V18.8636H20.5323V20.0909H15.521ZM18.3505 21V19.7159L18.3846 19.1818V15.1818H19.8619V21H18.3505Z"
              fill="#150C09"
            ></path>
          </g>
          <rect x="0.5" y="0.5" width="23" height="23" stroke="black"></rect>
        </g>
        <defs>
          <filter
            id="filter0_d_11954_5094"
            x="0"
            y="0"
            width="25.5"
            height="25.5"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            ></feColorMatrix>
            <feOffset dx="1.5" dy="1.5"></feOffset>
            <feComposite in2="hardAlpha" operator="out"></feComposite>
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
            ></feColorMatrix>
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11954_5094"
            ></feBlend>
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11954_5094"
              result="shape"
            ></feBlend>
          </filter>
          <clipPath id="clip0_11954_5094">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
      Sumplete
    </a>
    <a
      href="https://hitoriconquest.com"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center mb-4 ml-2 text-gray-0 hover:text-hey-brand-green text-[15px] font-semibold leading-normal"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2 -rotate-[8deg]"
      >
        <g filter="url(#filter0_d_11981_5483)">
          <g clipPath="url(#clip0_11981_5483)">
            <rect width="24" height="24" fill="white"></rect>
            <rect x="12" y="12" width="11" height="11" fill="#150C09"></rect>
            <rect x="1" y="1" width="11" height="11" fill="#150C09"></rect>
            <path d="M12 0V24" stroke="black" strokeWidth="0.923077"></path>
            <path d="M0 12H24" stroke="black" strokeWidth="0.923077"></path>
            <path
              d="M7.7152 3.18182V9H6.13565V4.63636H6.10156L4.82884 5.39773V4.05682L6.26065 3.18182H7.7152Z"
              fill="white"
            ></path>
            <path
              d="M18.7152 3.18182V9H17.1357V4.63636H17.1016L15.8288 5.39773V4.05682L17.2607 3.18182H18.7152Z"
              fill="#150C09"
            ></path>
            <path
              d="M7.7152 15.1818V21H6.13565V16.6364H6.10156L4.82884 17.3977V16.0568L6.26065 15.1818H7.7152Z"
              fill="#150C09"
            ></path>
            <path
              d="M15.8004 21V19.8636L17.9709 18.0682C18.1148 17.9489 18.2379 17.8371 18.3402 17.733C18.4444 17.6269 18.5239 17.518 18.5788 17.4062C18.6357 17.2945 18.6641 17.1705 18.6641 17.0341C18.6641 16.8845 18.6319 16.7566 18.5675 16.6506C18.505 16.5445 18.4179 16.4631 18.3061 16.4062C18.1944 16.3475 18.0656 16.3182 17.9197 16.3182C17.7739 16.3182 17.6451 16.3475 17.5334 16.4062C17.4235 16.465 17.3383 16.5511 17.2777 16.6648C17.2171 16.7784 17.1868 16.9167 17.1868 17.0795H15.6868C15.6868 16.6705 15.7786 16.3182 15.9624 16.0227C16.1461 15.7273 16.4055 15.5 16.7408 15.3409C17.076 15.1818 17.469 15.1023 17.9197 15.1023C18.3857 15.1023 18.7891 15.1771 19.13 15.3267C19.4728 15.4744 19.737 15.6828 19.9226 15.9517C20.1101 16.2206 20.2038 16.536 20.2038 16.8977C20.2038 17.1212 20.1574 17.3437 20.0646 17.5653C19.9718 17.785 19.8052 18.0284 19.5646 18.2955C19.3241 18.5625 18.9822 18.8807 18.5391 19.25L17.9936 19.7045V19.7386H20.2663V21H15.8004Z"
              fill="white"
            ></path>
          </g>
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            stroke="black"
            shapeRendering="crispEdges"
          ></rect>
        </g>
        <defs>
          <filter
            id="filter0_d_11981_5483"
            x="0"
            y="0"
            width="26"
            height="26"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            ></feColorMatrix>
            <feOffset dx="2" dy="2"></feOffset>
            <feComposite in2="hardAlpha" operator="out"></feComposite>
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
            ></feColorMatrix>
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11981_5483"
            ></feBlend>
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11981_5483"
              result="shape"
            ></feBlend>
          </filter>
          <clipPath id="clip0_11981_5483">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
      Hitori Conquest
    </a>
    <a
      href="https://www.wordga.com"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center mb-4 ml-2 text-gray-0 hover:text-hey-brand-green text-[15px] font-semibold leading-normal"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2 -rotate-[8deg]"
      >
        <g filter="url(#filter0_d_11954_5185)">
          <g clipPath="url(#clip0_11954_5185)">
            <rect width="24" height="24" fill="white"></rect>
            <rect
              width="15"
              height="6"
              transform="translate(9)"
              fill="#4F4644"
            ></rect>
            <rect
              width="18"
              height="8"
              transform="translate(0 8)"
              fill="#150C09"
            ></rect>
            <path
              d="M2.43478 13.5L1.8045 10.3708H2.59457L2.93634 12.3415L3.95278 10.3708H4.53868L4.89377 12.3593L5.88801 10.3708H6.71803L5.0935 13.5H4.44103L4.06819 11.6225L3.08726 13.5H2.43478ZM8.11785 13.5488C7.81899 13.5488 7.55859 13.4941 7.33666 13.3846C7.11473 13.2722 6.94162 13.1124 6.81734 12.9052C6.69602 12.6951 6.63536 12.4421 6.63536 12.1462C6.63536 11.7852 6.70638 11.4686 6.84841 11.1964C6.99045 10.9212 7.18871 10.7066 7.44319 10.5528C7.70062 10.3989 7.99801 10.322 8.33534 10.322C8.63421 10.322 8.89461 10.3782 9.11654 10.4906C9.33847 10.6001 9.51009 10.7599 9.63141 10.97C9.75569 11.1771 9.81783 11.4272 9.81783 11.7201C9.81783 12.0841 9.74682 12.4037 9.60478 12.6789C9.46275 12.9511 9.26449 13.1641 9.01001 13.318C8.75553 13.4719 8.45814 13.5488 8.11785 13.5488ZM8.12673 12.8653C8.30427 12.8653 8.45519 12.8179 8.57947 12.7232C8.70671 12.6286 8.80435 12.4969 8.87241 12.3282C8.94047 12.1566 8.9745 11.9598 8.9745 11.7379C8.9745 11.4893 8.91532 11.3059 8.79696 11.1875C8.68155 11.0662 8.52324 11.0055 8.32203 11.0055C8.14744 11.0055 7.99653 11.0529 7.86929 11.1475C7.74501 11.2422 7.64884 11.3754 7.58078 11.547C7.51568 11.7157 7.48313 11.911 7.48313 12.1329C7.48313 12.3815 7.54083 12.5664 7.65624 12.6877C7.77164 12.8061 7.92847 12.8653 8.12673 12.8653ZM10.0515 13.5L10.5486 10.3708H11.8935C12.2515 10.3708 12.5253 10.4507 12.7146 10.6105C12.907 10.7673 13.0032 10.9848 13.0032 11.2629C13.0032 11.5589 12.9247 11.7911 12.7679 11.9598C12.614 12.1255 12.4113 12.235 12.1598 12.2883C12.2456 12.3208 12.3181 12.3741 12.3773 12.4481C12.4365 12.5191 12.4868 12.6064 12.5282 12.7099L12.83 13.5H11.9956L11.6405 12.559C11.6109 12.4762 11.571 12.4185 11.5207 12.3859C11.4733 12.3504 11.4067 12.3326 11.3209 12.3326H11.0546L10.8682 13.5H10.0515ZM11.1434 11.7556H11.7337C12.0622 11.7556 12.2264 11.6166 12.2264 11.3384C12.2264 11.223 12.1879 11.1372 12.111 11.081C12.037 11.0247 11.9187 10.9966 11.7559 10.9966H11.2632L11.1434 11.7556ZM13.1854 13.5L13.6825 10.3708H14.7921C15.3189 10.3708 15.7243 10.4921 16.0083 10.7348C16.2954 10.9774 16.4389 11.3133 16.4389 11.7423C16.4418 12.0767 16.3738 12.377 16.2347 12.6434C16.0956 12.9097 15.89 13.1198 15.6177 13.2736C15.3485 13.4245 15.017 13.5 14.6235 13.5H13.1854ZM14.1042 12.8386H14.6324C14.949 12.8386 15.1872 12.741 15.347 12.5457C15.5097 12.3504 15.5911 12.087 15.5911 11.7556C15.5911 11.5219 15.5245 11.3428 15.3914 11.2186C15.2582 11.0943 15.0585 11.0321 14.7921 11.0321H14.3927L14.1042 12.8386Z"
              fill="white"
            ></path>
            <rect
              width="4"
              height="8"
              transform="translate(20 8)"
              fill="#4F4644"
            ></rect>
            <rect
              width="10"
              height="6"
              transform="translate(14 18)"
              fill="#4F4644"
            ></rect>
            <rect
              width="12"
              height="6"
              transform="translate(0 18)"
              fill="#4F4644"
            ></rect>
            <rect width="7" height="6" fill="#4F4644"></rect>
          </g>
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            stroke="black"
            shapeRendering="crispEdges"
          ></rect>
        </g>
        <defs>
          <filter
            id="filter0_d_11954_5185"
            x="0"
            y="0"
            width="26"
            height="26"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            ></feColorMatrix>
            <feOffset dx="2" dy="2"></feOffset>
            <feComposite in2="hardAlpha" operator="out"></feComposite>
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
            ></feColorMatrix>
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11954_5185"
            ></feBlend>
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11954_5185"
              result="shape"
            ></feBlend>
          </filter>
          <clipPath id="clip0_11954_5185">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
      Wordga
    </a>
  </nav>
</div>
`;

          export default {
            render(data = {}) {
              if (!data) data = {};

              let result = templateString;

              // First, process conditional if tags
              // Match pattern: {{:if attribute}}...{{:/if}}
              result = this._processIfTags(result, data);

              // Then replace variables
              result = result.replace(/\{\{\s*([^}]+)\s*\}\}/g, (match, key) => {
                const trimmedKey = key.trim();
                // Check if the property exists in data
                return (trimmedKey in data) ? data[trimmedKey] : match;
              });

              return result;
            },

            // Helper method to process if tags
            _processIfTags(template, data) {
              // Regular expression to match {{:if attribute}}...{{:/if}}
              const ifTagRegex = /\{\{:if\s+([^}]+)\}\}([\s\S]*?)\{\{:\/if\}\}/g;

              return template.replace(ifTagRegex, (match, attribute, content) => {
                let conditionMet = false;

                try {
                  // Parse the attribute path
                  const attributeParts = attribute.trim().split('.');
                  let value = data;

                  // Navigate through nested properties
                  for (const part of attributeParts) {
                    if (value === undefined || value === null) {
                      value = undefined;
                      break;
                    }
                    value = value[part];
                  }

                  // Check truthiness of the value
                  conditionMet = Boolean(value);
                } catch (error) {
                  console.warn('Error evaluating condition:', attribute, error);
                  conditionMet = false;
                }

                // Return the content if condition is met, otherwise empty string
                return conditionMet ? content : '';
              });
            },

            template: templateString
          };
        